export default __webpack_public_path__ + "static/media/preloader.3e1dae27.png";